import React, { FC } from "react";

import { pdfRendererStyles } from "@components/PdfViewer/styles";

import { useApplyTranslations } from "@hooks";
import { useConfigurationStore } from "@stores";

import PdfViewer from "./PdfViewer";

interface PdfRendererProps {
  fileUrl: string;
  fileName: string;
  hasMaxHeight?: boolean;
}

const PdfRenderer: FC<PdfRendererProps> = ({ fileUrl, fileName, hasMaxHeight }) => {
  const { domainSettings } = useConfigurationStore();
  const { use_documents_viewer = false } = domainSettings ?? {};
  const { t } = useApplyTranslations();

  if (!use_documents_viewer) {
    return (
      <div css={pdfRendererStyles}>
        <iframe
          src={fileUrl}
          className="pdf-renderer"
          allow="fullscreen"
          title={t("a11y.pdfViewer.thumbnail", { fileName })}
        />
      </div>
    );
  }

  return <PdfViewer fileUrl={fileUrl} hasMaxHeight={hasMaxHeight} />;
};

export default PdfRenderer;
